export default __webpack_public_path__ + "static/media/sprint-invitation.a1820b81.svg";